<template>
	<div class="steam-buynx-wrapper">
		<div class="steam-buynx">
			<div class="steam-pricepoints">
				<h4 class="heading-normal steam-pricepoints__title">
					{{ $t('wallet.select-nx-amount') }}
				</h4>

				<div v-for="(product, index) in products" :key="product.productId" class="steam-pricepoint-wrapper">
					<button
						class="btn btn-block btn-default steam-pricepoint"
						:class="{ selected: selectedProduct && selectedProduct.productId === product.productId }"
						@click="selectProduct(product, index + 1)"
					>
						<div class="steam-pricepoint__nxAmount">
							{{ $n(product.nxAmount) }}
						</div>
						<div class="steam-pricepoint__currency">{{ $n(product.amount, 'currency', product.currency) }}</div>
					</button>
				</div>

				<div class="steam-pricepoints__action">
					<button
						:disabled="!selectedProduct"
						:class="{ disabled: !selectedProduct }"
						class="btn btn-block btn-default"
						@click="selectedProduct && handleSelectedPricepoint()"
					>
						{{ $t('wallet.steam.checkout') }}
					</button>
				</div>
			</div>

			<div class="steam-buynx__important">
				{{ $t('wallet.steam.important') }}
			</div>
		</div>

		<div class="modal" :class="{ hide: !loading }">
			<div id="main-spinner" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
		</div>
	</div>
</template>

<script>
import config from '@/config/environment-config';
import { mapGetters } from 'vuex';

export default {
	name: 'SteamBuyNx',
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('wallet.add-balance')}`,
		};
	},
	data() {
		return {
			accountSettingPageUrl: `${config[process.env.NODE_ENV][environment.region].account}/setting`,
			loading: false,
			selectedProduct: null,
		};
	},
	computed: {
		...mapGetters({
			products: 'products',
		}),
		region() {
			return environment.region;
		},
		gamecode() {
			return this.$route.query.gamecode;
		},
		session() {
			return this.$route.query.session;
		},
	},
	mounted() {
		dataLayer.push({
			event: 'SW_Add Balance Select Page View',
			'SW_Add Balance Game': this.gamecode,
		});
	},
	methods: {
		selectProduct(product, buttonLocation) {
			if (!this.selectedProduct || this.selectedProduct.buttonLocation !== buttonLocation) {
				this.selectedProduct = { ...product, buttonLocation: buttonLocation };

				dataLayer.push({
					event: 'SW_Add Balance Select NX Amount',
					'SW_Add Balance Game': this.gamecode,
					'SW_NX Button Location': buttonLocation,
					'SW_NX Amount': this.selectedProduct.nxAmount,
				});
			}
		},
		handleCheckoutRedirection(token) {
			const checkoutWebBaseURL = config[process.env.NODE_ENV][environment.region].checkout;
			window.location = `${checkoutWebBaseURL}/${this.$i18n.locale}?token=${encodeURI(token)}&app_type=steam&gamecode=${
				this.gamecode
			}`;
		},
		async handleSelectedPricepoint() {
			this.loading = true;

			dataLayer.push({
				event: 'SW_Add Balance Checkout Click',
				'SW_Add Balance Game': this.gamecode,
				'SW_NX Button Location': this.selectedProduct.buttonLocation,
				'SW_NX Amount': this.selectedProduct.nxAmount,
			});

			this.$steamPurchaseAPI
				.getSteamCheckoutToken({
					productId: this.selectedProduct.productId,
					gamecode: this.gamecode,
					session: this.session,
				})
				.then((response) => {
					this.loading = false;
					this.handleCheckoutRedirection(encodeURI(response.data.token));
				});
		},
		faqClick() {
			dataLayer.push({
				event: 'SW_Add Balance FAQ',
				'SW_Add Balance Game': this.gamecode,
			});
		},
	},
};
</script>

<style lang="less" scoped>
.steam-buynx-wrapper {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	min-height: 360px;
}
.steam-buynx {
	text-align: center;
	max-width: 565px;
	width: 100%;
	margin-left: 20px;
	margin-right: 20px;
	margin-top: 90px;
	@media (max-width: 565px) {
		margin-left: 0;
		margin-right: 0;
	}
	.steam-pricepoints {
		display: flex;
		flex-wrap: wrap;
		flex: 0 0 100%;
		max-width: 100%;
		background-color: rgba(#000, 75%);
		border: 1px solid rgba(#fff, 25%);
		border-radius: 5px;
		padding-left: 12px;
		padding-right: 12px;
		@media (max-width: 565px) {
			border-left: none;
			border-right: none;
			border-radius: 0;
			padding-left: 15px;
			padding-right: 15px;
		}
		&__title {
			flex: 0 0 100%;
			max-width: 100%;
			color: #fff;
			font-size: 18px;
			font-weight: bold;
			margin-top: 15px;
			margin-bottom: 10px;
		}
		.steam-pricepoint-wrapper {
			flex: 0 0 33.33%;
			max-width: 33.33%;
			padding: 5px;
			@media (max-width: 600px) {
				flex: 0 0 50%;
				max-width: 50%;
			}
			@media (max-width: 430px) {
				flex: 0 0 100%;
				max-width: 100%;
			}
			.steam-pricepoint {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: space-between;
				position: relative;
				font-size: 14px;
				font-weight: bold;
				line-height: 1;
				height: 100%;
				border: 1px solid rgb(#fff, 25%);
				background-color: rgb(#fff, 10%);
				color: #fff;
				margin-top: 0;
				padding: 5px 10px 5px 5px;
				border-radius: 5px;
				transition: background-color 0.25s, border-color 0.25s;

				&__nxAmount {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					align-items: center;
					padding-right: 2px;
					&:before {
						content: '';
						display: inline-block;
						width: 30px;
						height: 30px;
						margin-right: 5px;
						background-image: url('~@/images/nx-icons/nx-coin.png');
						background-size: contain;
						background-repeat: no-repeat;
						background-position: center;
					}
				}
				&__currency {
					padding-top: 5px;
					padding-bottom: 5px;
					margin-left: auto;
				}
				&:hover,
				&:focus,
				&.selected,
				&.selected:active {
					background-color: rgba(#fff, 25%);
					border-color: rgba(#fff, 50%);
					transition: background-color 0.25s, border-color 0.25s;
				}
				&:active {
					background-color: rgba(#fff, 25%);
					border-color: rgba(#fff, 100%);
					transition: background-color 0.25s, border-color 0.25s;
				}
				&.selected {
					cursor: default;
				}
			}
		}
		&__action {
			flex: 0 0 100%;
			max-width: 100%;
			button {
				flex: 0 0 auto;
				width: auto;
				max-width: none;
				height: 30px;
				margin: 15px auto 20px auto;
				text-transform: uppercase;
				background-color: #07f;
				color: #fff;
				font-size: 14px;
				font-weight: bold;
				padding: 5px 30px;
				border-radius: 5px;
				border: none;
				&.disabled {
					background-color: rgba(#fff, 25%);
					color: rgba(#fff, 50%);
				}
				&:not(:active):not(.disabled):hover {
					background-color: #4ca1ff;
				}
				&:not(.disabled):active {
					background-color: #0052b3;
					color: rgba(#fff, 50%);
				}
			}
		}
	}
	&__important {
		font-size: 12px;
		line-height: 16px;
		color: rgba(#fff, 50%);
		margin-top: 5px;
		margin-bottom: 5px;
		a {
			color: #fff;
			text-decoration: underline;
			text-underline-position: under;
			transition: color 0.25s;
			&:hover {
				color: #0077ff;
				transition: color 0.25s;
			}
			&:active {
				color: #4ca1ff;
				transition: color 0.25s;
			}
		}

		@media (max-width: 565px) {
			margin-left: 44px;
			margin-right: 44px;
		}
		@media (max-width: 400px) {
			margin-left: 24px;
			margin-right: 24px;
		}
	}
}
</style>
